const pages = "/exam/"

export const UPDATE_QUESTIONS = `${pages}UPDATE_QUESTIONS`;
export const UPDATE_TIMER = `${pages}UPDATE_TIMER`;
export const UPDATE_LOADER = `${pages}UPDATE_LOADER`;

